import React from "react";
import { motion } from "framer-motion";
import { RESULT } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

const SKIN_IMG = "/generated/skin_mist.png";

const stats = [
  { v: "Confort instant" },
  { v: "Piele catifelată" },
  { v: "Eleganță discretă" },
];

export default function Result() {
  return (
    <section
      data-testid={RESULT.section}
      className="relative py-28 md:py-40 bg-[#FDFBF7] overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-y-10 md:gap-x-10 items-stretch">
          {/* Big image left */}
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease }}
            className="col-span-12 md:col-span-8 relative"
          >
            <div className="relative aspect-[4/5] md:aspect-[5/6] overflow-hidden bg-[#F4F0EA]">
              <img
                src={SKIN_IMG}
                alt="EILEA Body Milk Mist — micro-mist ultrafin"
                data-testid={RESULT.image}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Right column */}
          <div className="col-span-12 md:col-span-4 flex flex-col justify-between gap-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease, delay: 0.1 }}
            >
              <p className="overline mb-12">— Rezultatul</p>
              <h2
                data-testid={RESULT.caption}
                className="font-display text-3xl md:text-[2.4rem] leading-[1.15] text-[#2C2826] tracking-[-0.005em]"
              >
                Hidratare care devine{" "}
                <span className="accent-soft">
                  parte din piele.
                </span>
              </h2>
              <p className="mt-6 text-[15px] leading-[1.85] text-[#5C5652] font-light">
                O senzație discretă de confort care se așază pe piele
                și rămâne cu tine întreaga zi.
              </p>
            </motion.div>

            {/* Editorial sensory attribute list — no percentages */}
            <motion.dl
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                hidden: {},
                visible: { transition: { staggerChildren: 0.1 } },
              }}
              className="divide-y divide-[#E5DCD3] border-t border-b border-[#E5DCD3]"
            >
              {stats.map((s, i) => (
                <motion.div
                  key={s.v}
                  variants={{
                    hidden: { opacity: 0, y: 12 },
                    visible: { opacity: 1, y: 0 },
                  }}
                  transition={{ duration: 0.8, ease }}
                  className="flex items-baseline gap-6 py-6"
                >
                  <span className="overline text-[#8A7F77] shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <dt className="font-serif-classic text-xl md:text-[1.6rem] text-[#2C2826] tracking-[-0.005em]">
                    {s.v}
                  </dt>
                </motion.div>
              ))}
            </motion.dl>

            <p className="text-[10px] uppercase tracking-[0.18em] text-[#8A7F77]/80 leading-relaxed">
              Inspirat de ritualurile skincare. Creat pentru corp.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
